import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserManagementComponent } from './user-management.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserManagementService } from './user-management.service';
import { SharedModule } from '../shared/shared.module';
import { AddUserComponent } from './add-user.component';
import { HelpUserComponent } from './user-help.component';
import { UserService } from './user.service';
import { UserMenuComponent } from './user-menu.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
@NgModule({
    declarations: [
        UserManagementComponent,
        AddUserComponent,
        HelpUserComponent,
        UserMenuComponent
    ],
    imports: [
        ReactiveFormsModule,
        SharedModule,
        FormsModule,
        MatDialogModule,
        MatInputModule,
        MatRadioModule,
        MatSlideToggleModule,
        MatAutocompleteModule,
        MatTableModule
    ],
    providers: [UserManagementService, UserService]
})

export class UserManagementModule {

}